/** @file Fix animations of a mirrorFix direction: per base name, the animation played on the reserved track. */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { Doc, Id } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';
import { Select } from '../../ui-kit/Select';
import { animationBases } from './animationBases';

/** Props of FixAnimations; `onChange(base, null)` removes that base's fix animation. */
export interface FixAnimationsProps {
  doc: Doc;
  t: Translate;
  animations: Readonly<Record<string, Id>>;
  onChange: (base: string, animation: Id | null) => void;
}

/** One Select per base; the base name is data and doubles as the Select's accessible name. */
export function FixAnimations({ doc, t, animations, onChange }: FixAnimationsProps) {
  const options = [{ value: '', label: t('panels.directions.noChoice') }, ...entriesByName(doc.animations).map(([value, a]) => ({ value, label: a.name }))];
  return (
    <fieldset className="rig-fields">
      <legend>{t('panels.directions.fixAnimations')}</legend>
      {animationBases(doc).map((base) => (
        <div key={base} className="rig-row">
          {base}
          <Select label={base} value={animations[base] ?? ''} options={options} onChange={(id) => { onChange(base, id === '' ? null : id); }} />
        </div>
      ))}
    </fieldset>
  );
}
